import { EntityRepository, Repository } from "typeorm";
import { StockTransferLog } from "../entities/stock-transfer-log";

@EntityRepository(StockTransferLog)
export class StockTransferLogRepository extends Repository<StockTransferLog> {

    
}